import Base from "../base";
import { useTranslation } from "react-i18next";
import { faCartShopping, faSpinnerThird } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState, useEffect } from "react";
import axiosConfig from "../../services/Axios";
import SearchItem from "../../components/ui/Forms/SearchItem";
import Pagination from "../../components/ui/Pagination";
import Title from "../../components/ui/Title";
import BasketButton from "./BasketButton";
import ItemThumbs from "./ItemThumbs";
import EmptyData from "../../components/ui/EmptyData";

function Shop() {
  const [items, setItems] = useState(false);
  const [formData, setFormData] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    loadItems(formData);
  }, [formData]);

  const loadItems = () => {
    let itemsPerPage = 12;
    let url =
      process.env.REACT_APP_API_URL +
      (formData?.page ? formData?.page + "&" : "/api/shop?pagination=true");

    if (itemsPerPage) {
      url = url + "&itemsPerPage=" + itemsPerPage;
    }

    if (formData?.name) {
      url = url + "&name=" + formData.name;
    }

    if (formData?.itemCategory) {
      url = url + "&itemCategory=" + formData.itemCategory;
    }

    if (formData?.itemSubCategory) {
      url = url + "&itemSubCategory=" + formData.itemSubCategory;
    }

    axiosConfig.get(url).then((response) => {
      if (response?.status === 200 && response?.data) {
        setItems(response.data);
      }
    });
  };

  return (
    <Base>
      <div className="mainContainer">
        <div>
          <Title icon={faCartShopping} title={t("shop.title")} />
          <SearchItem
            formData={formData}
            setFormData={setFormData}
            className="px-6 shadow"
          />
        </div>
        <div className="grid grid-cols-12 gap-4 mt-4">
          {items ?
            items["hydra:member"].length > 0 ? (
              items["hydra:member"].map((item, key) => (
                <div
                  key={key}
                  className="col-span-12 md:col-span-6 xl:col-span-3 bg-white shadow p-3 rounded"
                >
                  <div className="font-bold p-4 pt-2">
                    {item.name.toUpperCase()}
                  </div>
                  <div className="h-80 relative">
                    <ItemThumbs item={item} height={80} />
                  </div>
                  <div className="justify-between flex items-center p-3 mt-2">
                    <div className="leading-3 text-bioport-orange-dark italic text-sm justify-center">
                      <span className="font-bold text-lg">
                        {item.currentAvailableQuantity}
                      </span>
                      <br />
                      <span className="text-sm">
                        {item.currentAvailableQuantity > 1
                          ? t("shop.availableQuantity_other")
                          : t("shop.availableQuantity_one")}
                      </span>
                    </div>
                    <BasketButton item={item} />
                  </div>
                </div>
              ))
            ) : (
              <div className="col-span-12">
                <EmptyData>{t("global.no-result")}</EmptyData>
              </div>
            )
        :
        <div className="text-center col-span-12">
          <FontAwesomeIcon
            icon={faSpinnerThird}
            size="3x"
            className="text-bioport-orange-dark"
            spin
          />
        </div>
        }
        </div>
        {items &&
          items["hydra:member"] &&
          items["hydra:totalItems"] > items["hydra:member"].length &&
          items["hydra:view"] && (
            <Pagination
              data={items}
              onClick={(page) => {
                setFormData((formData) => ({
                  ...formData,
                  page: page,
                }));
              }}
            />
          )}
      </div>
    </Base>
  );
}

export default Shop;
